module.exports = __webpack_public_path__ + "static/media/carolina-herrera-good-girl-collector-edition-big.0681f405.png";